module.exports = __webpack_public_path__ + "static/media/qualified.be2cf55c.png";